import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import TimesheetCategoryDropdown from "pages/TimeSheetManage/Dropdowns/TimesheetCategoryDropdown";
import { map } from "lodash";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // No dropdown, so no show state needed
  const [categoryValue, setCategoryValue] = useState([]);



  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setCategoryValue([]);
  };

  const handleSearch = () => {
    onFilter();
  };

  // No cancel button needed in flex form

  const handleCategoryChange = (selected) => {
    setCategoryValue(selected);
    const categoryIds = map(selected, 'value');
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, category_id: categoryIds },
    }));
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col md={10} sm={12}>
            <TimesheetCategoryDropdown
              selectedId={extraFiltersState.values.category_id}
              categoryOnChange={handleCategoryChange}
              categoryValue={categoryValue}
              setCategoryValue={setCategoryValue}
              isMulti={true}
            />
          </Col>
          <Col md={1} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100 mb-3"
            >
              <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
            </button>
          </Col>
          <Col md={1} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-link text-danger w-100 mb-2"
            >
              Clear
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
